
































































import { Component, Vue } from "vue-property-decorator";


@Component
export default class Resume extends Vue {
  demoInfo: Array<{ title: string; path: string; imagePath: string }> = [];

  constructor() {
    super();
    this.demoInfo = [];
  }
  handleAidun(){
      this.$router.push({ path: '/home' });
  }
  handlePublications(){
      window.open("https://ieeexplore.ieee.org/document/10440553");
  }
}
